import React, { Fragment } from 'react';

const WhenBook = () => (
  <Fragment>
    <p>The following hours are when you can start your booking:</p>
    <ul>
      <li>1am, 3am, 5am, 7am, 9am, 11am</li>
      <li>1pm, 3pm, 5pm, 7pm, 9pm, 11pm</li>
    </ul>
    <br />
    <p>
      Bookings must be a minimum of 6 hours, and you have the option to
      extend them in increments of 2 hours. Alternatively, you can choose
      daily bookings, allowing you to reserve a vehicle for up to 24 hours
      with the option to extend your booking for up to a maximum of 7
      consecutive days.
    </p>
    <br />
    <p>
      We recommend that you book a minimum of <strong>8 hours</strong> per
      booking in order to maximize your earnings
    </p>
  </Fragment>
);

export default WhenBook;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/WhenBook.js